import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ClientRelatedListResponseDTO,
	type ClientRelatedPinRequestDTO,
	postPropertyIdRelatedV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePinPropertyRelatedMutation = (id: number) => {
	const queryClient = useQueryClient();

	return useMutation<
		ClientRelatedListResponseDTO,
		Error,
		ClientRelatedPinRequestDTO
	>({
		mutationFn: processResponse((requestContract) =>
			postPropertyIdRelatedV2(requestContract, id),
		),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: PortfolioKeys.all });
		},
	});
};
